/* eslint-disable @typescript-eslint/camelcase */

// Using exported variables for the action types makes development less error-prone

/** The available actions for dispatching items */
import { AnyItem, DSTItemType } from './itemDefinitions';

export enum ItemActions {
  create,
  createOrAddAttendees,
  createBatch,
  remove = 'DELETE',
  clearAll = 'CLEAR_ALL',
  clearType = 'CLEAR_TYPE',
  updateId = 'UPDATE_ID',
  update = 'UPDATE',
  resetItem = 'RESET_ITEM',
}

interface ItemAction<S> {
  type: string;
  item?: S;
  itemType?: DSTItemType;
  key?: string;
  value?: string[] | string;
  id?: string;
  tempId?: string;
  newParent?: string;
  child?: string;
  batch?: S[];
}

export const itemReducer = <S extends AnyItem>(state: S[], action: ItemAction<S>): S[] => {
  switch (action.type) {
    case ItemActions.create:
      return action.item ? state.concat(action.item) : state;
    case ItemActions.createBatch:
      return action.batch ? state.concat(action.batch) : state;
    case ItemActions.createOrAddAttendees:
      if (action.item) {
        if (state.find((sItem) => sItem.id === action.item!.id) !== undefined) {
          if (action.item.guestsCanSeeOtherGuests !== false) {
            return state;
          }
          if (action.item.attendees) {
            return state.map((sItem) =>
              sItem.attendees && action.item!.id && sItem.id === action.item!.id
                ? {
                    ...sItem,
                    attendees: sItem.attendees.concat(
                      action.item!.attendees!.filter(
                        (att) => !sItem.attendees!.map((sAtt) => sAtt.email).includes(att.email)
                      )
                    )
                  }
                : sItem
            );
          }
          return state;
        }
        return state.concat(action.item);
      }
      return state;
    case ItemActions.remove:
      return state.filter((item) => item.id !== action.id);
    case ItemActions.clearAll:
      return [];
    case ItemActions.clearType:
      return state.filter((item) => item.itemType !== action.itemType);
    case ItemActions.updateId:
      return state.map((item) =>
        action.id && item.id === action.tempId ? { ...item, id: action.id } : item
      );
    case ItemActions.update:
      return state.map((item) =>
        action.key && item.id === action.id ? { ...item, [action.key]: action.value } : item
      );
    case ItemActions.resetItem:
      return state.map((item) => (action.item && item.id === action.id ? action.item : item));
    default:
      return state;
  }
};

export enum IdListActions {
  create,
  remove = 'DELETE',
  clearAll = 'CLEAR_ALL',
  clearAfter = 'CLEAR_AFTER'
}

interface IdListAction {
  type: string;
  id?: string;
}

export const idListReducer = (state: string[], action: IdListAction): string[] => {
  switch (action.type) {
    case IdListActions.create:
      return action.id ? state.concat(action.id) : state;
    case IdListActions.remove:
      return state.filter((id) => id !== action.id);
    case IdListActions.clearAfter:
      if (action.id && state.includes(action.id)) {
        return state.slice(0, state.indexOf(action.id) + 1);
      }
      return state;
    case IdListActions.clearAll:
      return [];
    default:
      return state;
  }
};

export enum FileListActions {
  create,
  remove = 'DELETE',
  clearAll = 'CLEAR_ALL'
}

interface File {
  name: string;
  comtent: string;
}

interface FileListAction {
  type: string;
  name?: string;
  file?: File;
}

export const fileListReducer = (state: File[], action: FileListAction): File[] => {
  switch (action.type) {
    case FileListActions.create:
      return action.file ? state.concat(action.file) : state;
    case FileListActions.remove:
      return state.filter((file) => file.name !== action.name);
    case FileListActions.clearAll:
      return [];
    default:
      return state;
  }
};
